import { CSSProperties } from 'react';

import '../../assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css';

export const LineAwesomeIcon = ({
  name,
  className = '',
  style,
}: {
  name: string;
  className?: string;
  style?: CSSProperties;
}) => {
  const classNameAppended = `las la-${name} ${className}`;
  return <i className={classNameAppended} style={style} />;
};
